import type { Route } from 'vue-router'
import type { Store } from 'vuex'

import type { GuardResolveFunction } from '../models'
import { CONTAINER } from '../config'

import { TYPES } from '../config/inversify.types'
import { GuardClass } from '../models'

import { CONFIG_CONSTS } from '../store/config/config.consts'

export class LoadConfigGuard extends GuardClass {
  static async execute(
    this: void,
    to: Route,
    from: Route,
    next: GuardResolveFunction,
  ): Promise<void> {
    const store = CONTAINER.get<Store<any>>(TYPES.Store)
    if (!store.getters[`${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.getters.instances}`].length) {
      await store.dispatch(`${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.actions.loadInstances}`)
    }
    next()
  }
}
